import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Zap, Leaf, GitBranch } from 'lucide-react';
const features = [{
  title: 'One API for FPGAs & ASICs',
  description: 'Access Xilinx, Intel, Lattice FPGAs — and custom ASICs — through a single unified interface. OpenAI-compatible SDK works out of the box.',
  icon: Layers
}, {
  title: 'Ultra-Low Latency',
  description: 'Hardware-level inference with deterministic sub-millisecond timing. No cold starts, no queue waits.',
  icon: Zap
}, {
  title: 'Power Efficient',
  description: '10x lower power consumption than GPU inference. Reduce costs and carbon footprint significantly.',
  icon: Leaf
}, {
  title: 'Bitstream Management',
  description: 'Deploy, version, and hot-swap FPGA bitstreams seamlessly across providers with zero downtime.',
  icon: GitBranch
}];
export function FeatureCards() {
  return <div className="py-24 bg-gate-dark" data-id="element-66">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-68">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group relative p-6 bg-gate-surface rounded-xl border border-gate-border hover:border-gate-teal/50 transition-all duration-300 hover:shadow-[0_0_30px_-10px_rgba(0,212,170,0.15)]" data-id="element-69">
              <div className="absolute inset-0 bg-gradient-to-br from-gate-teal/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" data-id="element-70" />

              <div className="relative z-10" data-id="element-71">
                <div className="w-12 h-12 rounded-lg bg-gate-dark border border-gate-border flex items-center justify-center mb-4 group-hover:border-gate-teal/50 group-hover:text-gate-teal transition-colors text-gate-text-secondary" data-id="element-72">
                  <feature.icon className="w-6 h-6" data-id="element-73" />
                </div>

                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-gate-teal transition-colors" data-id="element-74">
                  {feature.title}
                </h3>

                <p className="text-gate-text-secondary text-sm leading-relaxed" data-id="element-75">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}